import React, { useContext } from "react";
import { GridLegacy as Grid, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IPreferences } from "../../logic/api";
import EditableGroup, {
    EditableGroupType,
} from "../../components/editable/EditableGroup/EditableGroup";
import NotchedCard from "../../components/cards/NotchedCard/NotchedCard";
import { BrandManagementCard } from "./BrandManagementCard";
import styles from "../../pages/settings/styles";
import { SessionContext } from "@/utility/useSession";

interface BrandManagementSettingsProps {
    onSave: (data: Partial<IPreferences>) => Promise<boolean>;
}

export const BrandManagementSettings: React.FC<BrandManagementSettingsProps> = ({
    onSave
}) => {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    if (!session.current.site?.preferences.brand_enabled) {
        return null;
    }

    return (
        <Grid item xs={12}>
            <NotchedCard
                label={t("menuItems.brand")}
                containerProps={{ 'data-testid': 'brand-management-settings-card' }}
                style={styles.card}
            >
                <EditableGroup<IPreferences>
                    id="brandManagement"
                    editType={EditableGroupType.alwaysEditing}
                    data={session.current.site?.preferences}
                    onDataChanged={onSave}
                    testId="brand-management-settings"
                >
                    <Grid container>
                        <Grid item xs={12}>
                            <Box sx={{ mt: 1 }}>
                                <BrandManagementCard />
                            </Box>
                        </Grid>
                    </Grid>
                </EditableGroup>
            </NotchedCard>
        </Grid>
    );
};